import { Trans } from '@lingui/react/macro';
import { Box, TextInput } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { ErrorMessage } from 'shared/domains/forms/components/ErrorMessage';
import { FieldMessage } from 'shared/domains/forms/components/FieldMessage';
import { AnimateHeightContainer } from '../styled';
export function TextInputField(props) {
    const { name, label } = props;
    const { isSubmitting } = useFormikContext();
    const [field, meta] = useField(name);
    const error = Boolean(meta.touched && meta.error);
    const disabled = isSubmitting;
    const lengthWarning = field.value.length > 50;
    return (<div>
      <TextInput disabled={disabled} stretch label={label} {...field} invalid={error}/>
      <Box flexDirection="column" gap="md">
        <AnimateHeightContainer $isOpen={error}>
          <ErrorMessage name={name} show/>
        </AnimateHeightContainer>
        <AnimateHeightContainer $isOpen={lengthWarning}>
          <FieldMessage show>
            <Trans comment="Error message when text us to long">Keep the text short and descriptive</Trans>
          </FieldMessage>
        </AnimateHeightContainer>
      </Box>
    </div>);
}
